import React from 'react';
import {
  AddConnectorSkeletonContainer,
  BreadcrumbsSkeletonContainer,
  ButtonsSkeletonContainer,
  HeaderSkeletonContainer,
  ProgressSkeletonContainer,
  ProgressStepsSkeletonContainer,
  StepsSkeletonContainer,
} from './AddConnector.skeleton.styles';
import { Skeleton, useTheme } from '@cherre-frontend/ui';

const AddConnector: React.FC = () => {
  const theme = useTheme();
  return (
    <AddConnectorSkeletonContainer>
      <BreadcrumbsSkeletonContainer>
        <Skeleton animation='wave' variant='rectangular' height={37} />
      </BreadcrumbsSkeletonContainer>
      <HeaderSkeletonContainer>
        <Skeleton
          variant='rectangular'
          animation='wave'
          height={86}
          width={130}
        />

        <Skeleton
          variant='rectangular'
          width='100%'
          animation='wave'
          height={86}
        />
        <ProgressSkeletonContainer theme={theme}>
          <Skeleton variant='rectangular' animation='wave' height={21} />
          <ProgressStepsSkeletonContainer>
            <Skeleton
              variant='rectangular'
              animation='wave'
              width={100}
              height={41}
            />
            <Skeleton
              variant='rectangular'
              animation='wave'
              width={100}
              height={41}
            />
            <Skeleton
              variant='rectangular'
              animation='wave'
              width={100}
              height={41}
            />
          </ProgressStepsSkeletonContainer>
        </ProgressSkeletonContainer>
      </HeaderSkeletonContainer>
      <StepsSkeletonContainer>
        <Skeleton
          variant='rectangular'
          animation='wave'
          width={372}
          height={139}
        />
        <Skeleton
          variant='rectangular'
          animation='wave'
          width={46}
          height={139}
        />
        <Skeleton
          variant='rectangular'
          animation='wave'
          width={372}
          height={139}
        />
        <Skeleton
          variant='rectangular'
          animation='wave'
          width={46}
          height={139}
        />
        <Skeleton
          variant='rectangular'
          animation='wave'
          width={372}
          height={139}
        />
      </StepsSkeletonContainer>

      <ButtonsSkeletonContainer>
        <Skeleton
          variant='rectangular'
          animation='wave'
          height={37}
          width={138}
        />
        <Skeleton
          variant='rectangular'
          animation='wave'
          height={37}
          width={226}
        />
      </ButtonsSkeletonContainer>
    </AddConnectorSkeletonContainer>
  );
};

export default AddConnector;
